module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-01-dcaa8e82f5c8eaa0a6975eb29f9e67a6.jpg";